(function () {
  function isEnglishCart() {
    var host = window.location.hostname.replace(/^www\./, '');
    var path = window.location.pathname || '';

    if (host !== '0-signature.com') return false;
    return path === '/en/cart' || path.indexOf('/en/cart') === 0;
  }

  function updateEmptyCartLink() {
    if (!isEnglishCart()) return;

    var buttons = document.querySelectorAll('.empty-state a.button');
    if (!buttons.length) return;

    buttons.forEach(function (btn) {
      var href = btn.getAttribute('href') || '';
      if (
        href === '/' ||
        href === 'https://0-signature.com/' ||
        href === 'https://0-signature.com'
      ) {
        btn.setAttribute('href', 'https://0-signature.com/en/');
      }
    });
  }

  function init() {
    updateEmptyCartLink();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
